import React from 'react';

type LightningIconProps = {
    size?: number;
    color?: string;
    className?: string;
    style?: React.CSSProperties;
};

export const LightningIcon: React.FC<LightningIconProps> = ({
    size = 16,
    color = '#0ea5e9',
    className = 'inline-block',
    style = {verticalAlign: '-0.125em'},
}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}>
            <circle cx="8" cy="8" r="8" fill={color} />
            <path
                d="M 10 2 L 4 9 L 8 9 L 6 14 L 12 7 L 8 7 L 10 2"
                fill="white"
                stroke="none"
            />
        </svg>
    );
};
